import { render, staticRenderFns } from "./OrderChart.vue?vue&type=template&id=62a51440&scoped=true&"
import script from "./OrderChart.vue?vue&type=script&lang=js&"
export * from "./OrderChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderChart.vue?vue&type=style&index=0&id=62a51440&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a51440",
  null
  
)

component.options.__file = "OrderChart.vue"
export default component.exports